export const addDataSourcePermissions = ['datasources', 'datasource', ['c', 'u', 'd']];
